import { cva, type VariantProps } from "class-variance-authority";
import clsx from "clsx";

import type { InputHTMLAttributes } from "react";

const radioVariants = cva(
  "shrink-0 appearance-none rounded-full border-2 border-black-400 transition-[border-color] checked:border-[5px]",
  {
    variants: {
      size: {
        sm: "size-4",
        md: "size-5",
      },
      variant: {
        black: "checked:border-black-950",
        purple: "checked:border-purple-600",
      },
    },
    defaultVariants: {
      size: "md",
      variant: "black",
    },
  },
);
type RadioButtonProps = Omit<
  InputHTMLAttributes<HTMLInputElement>,
  "size" | "type"
> &
  VariantProps<typeof radioVariants> &
  (
    | { children?: string; isStyleOnly?: false }
    | { children?: never; isStyleOnly?: true }
  );

export default function RadioButton({
  size,
  variant,
  checked,
  className,
  isStyleOnly = false,
  ...rest
}: RadioButtonProps) {
  if (isStyleOnly) {
    const checkedClassName =
      checked &&
      clsx(
        "border-[5px]",
        variant === "black" ? "border-black-950" : "border-purple-600",
      );

    return (
      <div
        className={clsx(
          radioVariants({ size, variant }),
          checkedClassName,
          className,
        )}
        {...rest}
      />
    );
  }
  return (
    <input
      className={clsx(radioVariants({ size, variant }), className)}
      type="radio"
      checked={checked}
      {...rest}
    />
  );
}
